import { SIGN_IN } from '../../types/types';

export default ( state = {}, action: any) => {
  switch( action.type ) {
    case SIGN_IN:
      return { ...state, user: action.payload };
    default:
      return state;
  }
}